import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
root: {
    display: 'flex',
    justifyContent: 'space-evenly',
    [theme.breakpoints.between('xs', 'sm')]: {
        flexWrap: 'wrap',
    },
    flexGrow: 1,
  }
}));